export default () => ({
  nombre: "",
  description: "",
  status: true,
  teams: [],
});
